<template>
  <v-app id="finance_calculator" dark>

    <!--calculate monthly payment-->
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card light>
              <v-card-text class="subheading orange lighten-3 mb-5">
                      <v-icon medium light class="mr-3">info</v-icon> Once you have decided on the perfect vehicle, we'll work with you to arrange your financing. We have a variety of terms to suit your needs. Enter your email address and phone
                      number to get pre-approved before you buy, putting more negotiating power in your hands.
              </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md2 lg2> <v-subheader>Price of Vehicle</v-subheader></v-flex>
        <v-flex xs7>
          <v-slider dark tabindex="0" v-bind:max="500000" :min="1" v-model="vehicle_price"></v-slider>
        </v-flex>
        <v-flex xs3>
          <v-text-field v-model="vehicle_price" type="number" max="500000" :min="1" hint="Typing is enabled" :persistent-hint=true prefix="$"></v-text-field>
        </v-flex>
        <v-flex xs12 md2 lg2> <v-subheader>Downpayment</v-subheader></v-flex>
        <v-flex xs7>
          <v-slider tabindex="1"  v-bind:max="99" :min="0" v-model="down_payment"></v-slider>
        </v-flex>
        <v-flex xs3>
          <v-text-field v-model="down_payment" type="number" v-bind:max="99" :min="10" hint="Typing is enabled" :persistent-hint=true suffix="%"></v-text-field>
        </v-flex>
        <v-flex xs12 md2 lg2> <v-subheader>Payment term</v-subheader></v-flex>
        <v-flex xs7>
          <v-slider v-bind:max="7" :min="4" v-model="loan_duration"></v-slider>
        </v-flex>
        <v-flex xs3>
          <v-text-field v-model="loan_duration" type="number" v-bind:max="7" :min="1" hint="Typing is enabled" :persistent-hint=true suffix="Years"></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <!--end calculate monthly payment-->

    <v-divider></v-divider>

    <!--display monthly payment-->

    <v-container fluid v-show="calculation_valid">
      <v-layout row wrap>
        <v-flex xs6 md9 lg9>
          <v-card class="grey darken-2">
            <v-card-text>
                <v-subheader class="title">Your total amount for financing is</v-subheader>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs6 md3 lg3>
          <v-card class="grey darken-2">
            <v-card-text>
                <v-subheader class="headline">$ {{calc_total_financed}}</v-subheader>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs6 md9 lg9 mt-2>
          <v-card class="grey darken-2">
            <v-card-text>
                <v-subheader class="title">Your total monthly payment is</v-subheader>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs6 md3 lg3 mt-2>
          <v-card class="grey darken-2">
            <v-card-text>
                <v-subheader class="headline green--text text--lighten-1">$ {{calc_monthly_paymt}}</v-subheader>
            </v-card-text>
          </v-card>
        </v-flex>

        <!--Get pre-approved modal form-->
        <v-flex xs-12>
          <modal-form :vehicle_price="vehicle_price" :down_payment="dpValue" :loan_duration="loan_duration" :interest_rate="interest_rate" :monthly_payment="monthly_payment" ></modal-form>
        </v-flex>
        <!--End pre-approved form-->

      </v-layout>
    </v-container>

    <!--end display monthly payment-->

    <!--Display errors if any-->

    <v-container fluid v-show="!calculation_valid">
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-text>
                <v-subheader class="title red--text text--accent-3">The data you entered is not valid.</v-subheader>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <!--End Display errors if any-->


  </v-app>
</template>

<script>
  import modalForm from '@/components/modalForm'
  export default {
    data () {
      return {
        vehicle_price: 25000,
        down_payment: 0, // in percentage
        dpDecimal: 0,
        dpValue: 0,
        loan_duration: 4, // in years
        durationInMonths: 0, // in months
        interest_rate: 1.24,
        totalFinanced: 9725,
        monthly_payment: 0,
        adminFee: 3000
      }
    },
    computed: {
      calc_total_financed: function () {
        this.dpDecimal = this.down_payment / 100
        this.dpValue = this.vehicle_price * this.dpDecimal
        this.totalFinanced = this.vehicle_price - this.dpValue
        return Math.floor(this.totalFinanced)
      },
      calc_monthly_paymt: function () {
        this.durationInMonths = this.loan_duration * 12
        /*
        example calculation is for 4 years – ((Cost of Vehicle – Down Payment + $3000) *1.24)/48 - where 1.24 is interest rate and 48 is the number of months for the payment term.
        */
        this.monthly_payment = ((this.totalFinanced + this.adminFee) * this.calc_interest_rate(this.durationInMonths)) / this.durationInMonths
        return Math.floor(this.monthly_payment)
      },
      calculation_valid: function () {
        return this.monthly_payment > -1
      }
    },
    components: {
      'modal-form': modalForm
    },
    methods: {
      /*
      Get the interest rate based on how many months (loanDuration) have been input.
       */
      calc_interest_rate: (loanDuration) => {
        let interestRate = 1.24
        switch (loanDuration) {
          /*
          48 months
          */
          case 48:
            interestRate = 1.24
            break
          case 60:
            interestRate = 1.30
            break
          case 72:
            interestRate = 1.36
            break
          case 84:
            interestRate = 1.42
            break
        }
        return interestRate
      }
    }
  }
</script>

<style lang="stylus">
  @import './stylus/main'
  #finance_calculator{
    background-color: #005697;
  }
</style>



// WEBPACK FOOTER //
// App.vue?fe814216